import React from 'react';

const SuccessSvg = () => {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M16 28C22.6274 28 28 22.6274 28 16C28 9.37258 22.6274 4 16 4C9.37258 4 4 9.37258 4 16C4 22.6274 9.37258 28 16 28Z" stroke="#30975b" stroke-width="2.75" strokeLinecap="round" stroke-linejoin="round"/>
      <path d="M12 15.9999L14.6667 18.6666L20 13.3333" stroke="#30975b" stroke-width="2.75" strokeLinecap="round" stroke-linejoin="round"/>
    </svg>
  )
}

export default SuccessSvg;